export default class Config {
    private static instance: Config;

    private configUrl: string | null;
    private configuration: any;

    constructor() {
        this.configUrl = null;
    }

    public static getInstance(): Config {
        if (this.instance === undefined) {
            this.instance = new Config();
        }
        return this.instance;
    }

    setConfigUrl(url: string): void {
        this.configUrl = url;
    }

    async getConfiguration() {
        if (this.configuration !== undefined) {
            return this.configuration;
        }

        if (this.configUrl !== null) {
            const response = await fetch(this.configUrl);

            if (!response.ok) {
                throw new Error(`Konfiguraci "${this.configUrl}" se nepodařilo načíst (HTTP ${response.status} ${response.statusText}).`);
            }

            // nginx má SPA fallback (try_files $uri $uri/ /index.html), takže když config.json
            // není nasazený, vrátí se index.html se statusem 200. Samotné response.ok proto nestačí.
            const body = await response.text();

            try {
                this.configuration = JSON.parse(body);
            } catch (error) {
                const looksLikeHtml = body.trimStart().startsWith("<");
                throw new Error(
                    looksLikeHtml
                        ? `Konfigurace "${this.configUrl}" není dostupná - server vrátil HTML místo JSON (soubor pravděpodobně není nasazený).`
                        : `Konfigurace "${this.configUrl}" není platný JSON.`
                );
            }

            return this.configuration;
        }

        return null;
    }
}